module.exports = __webpack_public_path__ + "static/media/t1.8d029088.jpg";